module.exports = __webpack_public_path__ + "static/media/instagram_icon.5599e5a7.svg";